<template>
	<div>
		<v-snackbar
			v-model="snackbar"
			:timeout="5000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>

		<div v-if="monthsToShow.length > 1">
			<planning-month
				v-for="(month, index) in monthsToShow"
				:key="index"
				:monthData="month"
				@showSnackbar="setSnackbarText($event)"
			></planning-month>
		</div>
		<div v-else-if="isLoading" class="pt-5 text-xs-center">
			<v-progress-circular color="accent" size="64" indeterminate></v-progress-circular>
		</div>
		<div v-else class="pt-5 text-xs-center">
			<h2>Daten konnten nicht geladen werden.</h2>
		</div>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
import moment from "moment";
import PlanningMonthComponent from "./planningMonthComponent.vue";

export default {
	components: {
		"planning-month": PlanningMonthComponent,
	},
	data() {
		return {
			currentDate: new Date(),
			monthsToShow: [], // contains months to show represented as Date
			isLoading: false,
			snackbar: false,
			snackbarText: "",
		};
	},
	mounted() {
		this.createInitialMonths();
	},
	computed: {},
	methods: {
		async createInitialMonths() {
			try {
				this.isLoading = true;
				this.showErrorMessage = false;

				const result = await httpClient().get(
					`api/Capacity/GetPlanningData?fertigerId=${this.$route.params.fertigerId}`
				);

				let monthRange = 12;
				// using "moment" because adding months in native javascript Dates is a pain
				let referenceDate = moment(
					new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1)
				);
				for (let i = 0; i < monthRange; i++) {
					let relevantDeliveryDays = result.data.deliveryDays
						.filter(
							(date) =>
								moment(date).year() === referenceDate.year() &&
								moment(date).month() === referenceDate.month()
						)
						.map(
							(date) =>
								new Date(
									moment(date).year(),
									moment(date).month(),
									moment(date).date()
								)
						);
					let relevantProductionDays = result.data.productionDays
						.filter(
							(date) =>
								moment(date).year() === referenceDate.year() &&
								moment(date).month() === referenceDate.month()
						)
						.map(
							(date) =>
								new Date(
									moment(date).year(),
									moment(date).month(),
									moment(date).date()
								)
						);
					let relevantFertigerHolidays = result.data.fertigerHolidays
						.filter(
							(date) =>
								moment(date).year() === referenceDate.year() &&
								moment(date).month() === referenceDate.month()
						)
						.map(
							(date) =>
								new Date(
									moment(date).year(),
									moment(date).month(),
									moment(date).date()
								)
						);
					let relevantPublicHolidays = result.data.publicHolidays
						.filter(
							(holiday) =>
								moment(holiday.date).year() === referenceDate.year() &&
								moment(holiday.date).month() === referenceDate.month()
						)
						.map((holiday) => ({
							name: holiday.name,
							date: new Date(
								moment(holiday.date).year(),
								moment(holiday.date).month(),
								moment(holiday.date).date()
							),
						}));

					let monthData = {
						date: new Date(referenceDate.year(), referenceDate.month(), 1),
						deliveryDays: relevantDeliveryDays,
						productionDays: relevantProductionDays,
						fertigerHolidays: relevantFertigerHolidays,
						publicHolidays: relevantPublicHolidays,
					};

					this.monthsToShow.push(monthData);
					referenceDate.add(1, "months");
				}
			} catch (ex) {
				console.log("Daten konnten nicht geladen werden.", ex);
			} finally {
				this.isLoading = false;
			}
		},
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>

<style scoped></style>
